module.exports = __webpack_public_path__ + "img/material.c2afd38d.png";